import { createAsyncThunk } from '@reduxjs/toolkit'
import { WorkspaceAgent } from '../../../../api/workspaceAgent'

export const updateWorkspaceOpenAiSettings = createAsyncThunk(
  'workspaces/open-ai/update',
  async ({ apiKey, organization }, thunkApi) => {
    try {
      const workspace = await WorkspaceAgent.updateOpenAiConfig(apiKey, organization)

      return { workspace }
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data)
    }
  },
)
